import { getSsoData } from 'modules/first-start/selectors/moduleSelectors';
import { useDispatch, useSelector } from 'modules/react-redux';
import { PROFILE_SETUP_SSO_PAGE_ID } from 'pages/auth/config';
import { useEffect } from 'react';
import { routingService } from 'services/routing';
import { getPath, Path } from 'urlBuilder';

import { showProfileSetupModule } from '../../actions';

/**
 * @deprecated Use Redesigned version
 */
export const useProfileSetupSsoPageData = () => {
    const dispatch = useDispatch();

    const ssoData = useSelector(getSsoData);

    useEffect(() => {
        if (ssoData) {
            dispatch(showProfileSetupModule(PROFILE_SETUP_SSO_PAGE_ID));
        } else {
            routingService.replace(getPath(Path.login));
        }
    }, [dispatch, ssoData]);
};
